var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "create-wrapper" }, [
    _c(
      "div",
      {
        staticClass: "__btn __btn_input",
        class: { active: !!_vm.name || _vm.inputItem === "name" }
      },
      [
        _c("form", { attrs: { autocomplete: "off" } }, [
          _c("input", {
            directives: [
              {
                name: "model",
                rawName: "v-model",
                value: _vm.name,
                expression: "name"
              }
            ],
            ref: "name",
            attrs: {
              type: "text",
              autocomplete: "off",
              placeholder: _vm.$t("accountName")
            },
            domProps: { value: _vm.name },
            on: {
              focus: function($event) {
                return _vm.inputFocus("name")
              },
              blur: function($event) {
                return _vm.inputBlur("name")
              },
              input: function($event) {
                if ($event.target.composing) {
                  return
                }
                _vm.name = $event.target.value
              }
            }
          })
        ])
      ]
    ),
    _vm._v(" "),
    _c(
      "div",
      {
        staticClass: "__btn __btn_input",
        class: { active: !!_vm.pass1 || _vm.inputItem === "pass1" }
      },
      [
        _c("form", { attrs: { autocomplete: "off" } }, [
          _c("input", {
            directives: [
              {
                name: "model",
                rawName: "v-model",
                value: _vm.pass1,
                expression: "pass1"
              }
            ],
            ref: "pass1",
            attrs: { type: "password", placeholder: _vm.$t("create.input") },
            domProps: { value: _vm.pass1 },
            on: {
              focus: function($event) {
                return _vm.inputFocus("pass1")
              },
              blur: function($event) {
                return _vm.inputBlur("pass1")
              },
              input: function($event) {
                if ($event.target.composing) {
                  return
                }
                _vm.pass1 = $event.target.value
              }
            }
          })
        ])
      ]
    ),
    _vm._v(" "),
    _c(
      "div",
      {
        staticClass: "__btn __btn_input",
        class: { active: !!_vm.pass2 || _vm.inputItem === "pass2" }
      },
      [
        _c("input", {
          directives: [
            {
              name: "model",
              rawName: "v-model",
              value: _vm.pass2,
              expression: "pass2"
            }
          ],
          ref: "pass2",
          attrs: {
            type: "password",
            autocomplete: "off",
            placeholder: _vm.$t("create.again")
          },
          domProps: { value: _vm.pass2 },
          on: {
            focus: function($event) {
              return _vm.inputFocus("pass2")
            },
            blur: function($event) {
              return _vm.inputBlur("pass2")
            },
            input: function($event) {
              if ($event.target.composing) {
                return
              }
              _vm.pass2 = $event.target.value
            }
          }
        })
      ]
    )
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }